export const PATHS = {
  DASHBOARD: {
    to: "/dashboard",
    roles: "admin",
  },
  ACCOUNT: {
    to: "/account",
    roles: "admin",
  },
  REQUESTS: {
    to: "/requests",
    roles: "admin",
  },
  APPOINTMENTS: {
    to: "/appointments",
    roles: "admin",
  },
  PATIENT_LIST: {
    to: "/patient-list",
    roles: "admin",
  },
  MESSAGES: {
    to: "/messages",
    roles: "admin",
  },

  SETTINGS: {
    to: "/settings",
    roles: "admin",
  },
  CASH_TRANSCATIONS: {
    to: "/transactions",
    roles: "admin"
  },
  CLAIM_VIEWER: {
    to: "/claimviewer",
    roles: "admin"
  },
  INPATIENT_VIEWER: {
    to: "/inpatientviewer",
    roles: "admin"
  },
  REDIRECTION: {
    to: "/claim/redirection",
    roles: "admin"
  },
  FINANCIAL: {
    to: "/financial",
    roles: "admin"
  },
  PRINTCOVERLETTER:{
    to: "/printcoverletter",
    permission: "canPrintCoverLetter"
  }
};
